(function () {
    'use strict';

    angular.module('app.errors', ['smart-table', 'treeControl', 'ui.bootstrap', 'ui.grid', 'ui.grid.pagination']);
})();